import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { BinaryBlob } from '@adornis/collab/db/scalars.js';

@Entity()
export class CollabContent extends MongoEntity {
  static override _class = 'CollabContent';
  static override _collectionName = 'collab-content';

  @Field(type => String)
  title: Maybe<string>;

  @Field(type => String)
  userID: Maybe<string>;

  @Field(type => BinaryBlob)
  content: Maybe<Uint8Array>;
}
